import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../../style/colors';
import { ITheme } from '../../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  paper: {
    height: 580,
    width: 400,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: `${theme.spacing(2)}px`,
    },
    textAlign: 'left',
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    placeContent: 'center',
    placeItems: 'center',
    overflowY: 'hidden',
    borderRadius: `${theme.spacing(2)}px`,
  },
  boldTypography: {
    fontWeight: 'bold',
  },
  description: {
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down(320)]: {
      padding: 0,
    },
  },
  topSection: {
    [theme.breakpoints.down(320)]: {
      padding: `0 ${theme.spacing(3)}px`,
    },
    padding: theme.spacing(3),
    position: 'absolute',
    top: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    placeContent: 'space-between',
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: `${theme.spacing(3)}px`,
    width: '100%',
    paddingBottom: 0,
    bottom: theme.spacing(3),
    position: 'absolute',
    textAlign: 'center',
  },
  title: {
    color: colors.darkestGray,
    [theme.breakpoints.down(320)]: {
      padding: 0,
    },
  },
  submitButton: {
    margin: 0,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    '&:disabled': {
      background: colors.darkestBlue,
      opacity: 0.5,
    },
  },
  links: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    paddingTop: 24,
  },
}));
